// FlyingPoints.jsx
import React from 'react';
import styles from './FlyingPoints.module.css';

export default function FlyingPoints({ amount }) {
  if (amount === null) return null;

  return <div className={styles.pointsFly}>+{amount}</div>;
}
